import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarButton from '../../_partials/items/ActionBarButton';
import { useSellOrResellAction } from '../../../Sidebar/SidebarBlock/layouts/exclusives/hooks';
import s from './SellYourArtLink.scss';
export const SellYourArtLink = ({ deviation, className })=>{
    const { t } = useTranslation();
    const [sellOrResellAction, sellOrResellBiData] = useSellOrResellAction(deviation);
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        className: className,
        popoverWrapperClassName: s['wrapper']
    }, /*#__PURE__*/ React.createElement(ActionBarButton, {
        className: s['button'],
        onClick: sellOrResellAction,
        biData: sellOrResellBiData
    }, t('actionbar.sellYourArt')));
};
SellYourArtLink.displayName = 'SellYourArtLink';
export default SellYourArtLink;
